import { render, staticRenderFns } from "./RefreshPage.vue?vue&type=template&id=55f1681b&scoped=true&"
import script from "./RefreshPage.vue?vue&type=script&lang=js&"
export * from "./RefreshPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f1681b",
  null
  
)

export default component.exports